import { trpc, TRPCReactQueryOptions } from '@sternum/web/services/trpc';

export type UseLogoutApiOptions = TRPCReactQueryOptions['auth']['logout'];

export function useLogoutApi(options: UseLogoutApiOptions = {}) {
  return trpc.auth.logout.useMutation(options);
}
